import { useMemo } from 'react';
import { UserAccountAccountType, useGetWithdrawableAmountQuery } from '@fintronners/react-api/src';
import useUserAccount from '@/hooks/api/useUserAccount';
import useCachedMarketData from '@fintronners/react-widgets/src/hooks/market/useCachedMarketData';
import useCurrentAccountType from '@/hooks/utils/useCurrentAccountType';

export const useWithdrawableAmount = (goalUid?: string) => {
  const nonDiscretionaryAccountTypes = useCurrentAccountType();

  const { userAccount, loading: loadingUserAccount } = useUserAccount(
    goalUid
      ? UserAccountAccountType.AccountTypeBrokerageDiscretionary
      : nonDiscretionaryAccountTypes,
  );

  const { fiatAsset, loading: loadingFiatAsset } = useCachedMarketData();

  const portfolioID = userAccount?.firstPortfolioId || '';
  const assetID = fiatAsset?.id || '';

  const queryResult = useGetWithdrawableAmountQuery({
    variables: {
      portfolioID,
      assetID,
    },
    fetchPolicy: 'network-only',
    skip: Boolean(goalUid) || !portfolioID || !assetID,
  });

  const loading = queryResult.loading || loadingUserAccount || loadingFiatAsset;

  return useMemo(
    () => ({
      ...queryResult,
      loading,
    }),
    [queryResult, loading],
  );
};
